import { getPayslipTheme } from './payslipStyles';
const clean = value => String(value || '').trim();

export function getPayslipCompanyDetails(company = {}) {
  const cfg = company.config || {};
  return {
    name: clean(company.name) || 'Company',
    address: clean(company.address || cfg.registered_address),
    contact: [company.phone, company.email || company.contact_email, company.website].map(clean).filter(Boolean).join('  |  '),
    registrations: [
      ['GSTIN', company.gst || company.gst_number || company.tin],
      ['PF Reg.', company.pf_number], ['ESI Code', company.esi_code], ['PT Reg.', company.pt_reg],
    ].filter(([, value]) => clean(value)).map(([label, value]) => `${label}: ${clean(value)}`).join('  |  '),
  };
}

// Only the payslip uses this header; letter and report layouts remain independent.
export function addPayslipCompanyHeader(doc, width, company, logoImage) {
  const details = getPayslipCompanyDetails(company);
  const theme = getPayslipTheme(company?.config?.payslip_style);
  const classic = theme.template === "classic";
  const margin = 14;
  const textX = logoImage ? margin + 28 : margin;
  const textWidth = width - margin - textX;
  const blocks = [
    { text: details.name, size: 15, weight: 'bold', color: classic ? [255, 255, 255] : theme.palette.rgb, lineHeight: 6.2 },
    { text: details.address, size: 8, weight: 'normal', color: classic ? [235, 241, 248] : [71, 85, 105], lineHeight: 3.7 },
    { text: details.contact, size: 7.5, weight: 'normal', color: classic ? [235, 241, 248] : [71, 85, 105], lineHeight: 3.5 },
    { text: details.registrations, size: 7.2, weight: 'normal', color: classic ? [235, 241, 248] : [71, 85, 105], lineHeight: 3.4 },
  ].filter(block => block.text).map(block => {
    doc.setFont('helvetica', block.weight); doc.setFontSize(block.size);
    return { ...block, lines: doc.splitTextToSize(block.text, textWidth) };
  });
  const contentHeight = blocks.reduce((height, block) => height + block.lines.length * block.lineHeight + 1.5, 0);
  const bottom = 10 + Math.max(24, contentHeight);
  doc.setFillColor(...(classic ? theme.palette.rgb : theme.palette.tint)); doc.rect(0, 0, width, bottom + 4, 'F');
  if (logoImage) {
    try { doc.addImage(logoImage, logoImage.startsWith('data:image/jpeg') ? 'JPEG' : 'PNG', margin, 10, 22, 22); } catch (_) { /* Company details remain readable if a logo cannot be drawn. */ }
  }
  let y = 14;
  blocks.forEach(block => {
    doc.setFont('helvetica', block.weight); doc.setFontSize(block.size); doc.setTextColor(...block.color);
    block.lines.forEach(line => { doc.text(line, textX, y); y += block.lineHeight; });
    y += 1.5;
  });
  doc.setDrawColor(...theme.palette.rgb); doc.setLineWidth(0.3); doc.line(margin, bottom + 4, width - margin, bottom + 4);
  return bottom + 8;
}
